// extracted by mini-css-extract-plugin
export default {"viewInfo":"ViewInfo_viewInfo__Vv5uU","title":"ViewInfo_title__jJICG"};